import React, { PropsWithChildren } from 'react';
import { Column } from '../contexts/column.context';
import { Row } from '../contexts/row.context';
import { STRIP_WIDTH, TOP_PLOT_HEADER_HEIGHT } from '../utils/graph.utils';
import { StripContent } from './StripContent';
import { StripPosition } from './StripPosition';

type Props = PropsWithChildren<{
  offset?: number;
  height?: number;
  dataTestId?: string;
}>;

export const PlotHeader: React.FC<Props> = ({
  offset = 0,
  height = TOP_PLOT_HEADER_HEIGHT,
  dataTestId,
  children,
}) => {
  return (
    <Row height={height} dataTestId={dataTestId}>
      <Column width={STRIP_WIDTH} offsetLeft={offset}>
        <StripContent overflow='auto'>
          <StripPosition>{children}</StripPosition>
        </StripContent>
      </Column>
    </Row>
  );
};
